import { AlertCircle, X } from "lucide-react";
import React from "react";

export default function ErrorNotification({ message, onClose }) {
  return (
    <div className="fixed top-4 right-4 z-50 animate-in fade-in duration-300">
      <div className="bg-red-50 border-l-4 border-red-500 p-4 rounded shadow-lg w-96">
        <div className="flex items-start">
          <div className="flex-shrink-0">
            <AlertCircle className="h-5 w-5 text-red-500" />
          </div>
          <div className="ml-3 w-full pr-4">
            <h3 className="text-sm font-medium text-red-800">Error</h3>
            <div className="mt-1">
              <p className="text-sm text-red-700">{message}</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="ml-auto flex-shrink-0 -mr-1 -mt-1"
          >
            <X className="h-5 w-5 text-red-500 hover:text-red-600" />
          </button>
        </div>
      </div>
    </div>
  );
}
